import { useRef, useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import { MdDomainVerification } from "react-icons/md";
import { useStores } from "../../store/index";

export default function MobileVerification({ popUpInitialValue, handlePopup }) {
  const { UserStore, PopupStore } = useStores();
  const [popup, setPopup] = useState(popUpInitialValue);
  const [showotpinput, setShowotpinput] = useState(false);

  const mobileref = useRef(null);
  const otpref = useRef(null);

  const buttonvalue = showotpinput ? "Verify" : "Send OTP";

  const closePopUp = () => {
    handlePopup();
  };

  const sendotp = (e) => {
    e.preventDefault();
    try {
      if (buttonvalue === "Send OTP") {
        UserStore.postDetailsForMobileVerification(
          UserStore.userDetails?._id,
          mobileref.current.value
        );
        setShowotpinput(true);
      }

      if (buttonvalue === "Verify") {
        UserStore.postOtpForMobileVerification(
          UserStore.userDetails?._id,
          otpref.current.value
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      {popup ? (
        <div onClick={() => closePopUp} className="absolute w-screen h-screen z-50 inset-0 backdrop-filter backdrop-blur-sm bg-black bg-opacity-40">
          <div onClick={(e) => e.stopPropagation()} className="fixed  inset-0 bg-bg3 z-50 flex flex-col justify-center rounded items-center md:w-[25%] lg:w-[25%] w-[90%] h-[65vh] m-auto shadow-lg overflow-y-auto no-scrollbar">
            <div className="flex flex-col  items-center justify-center w-[100%] h-full   py-10 ">
              <AiFillCloseCircle
                onClick={closePopUp}
                className="text-primary absolute text-2xl cursor-pointer  top-2 right-2"
              />
              {/* <Lottie
                                options={defaultOptions}
                                height={200} // Adjust the height of the Lottie animation as needed
                                width={200} // Adjust the width of the L    ottie animation as needed
                            /> */}
              <MdDomainVerification className="text-primary  text-5xl border-b-2 border-bg3" />
              <p className="text-black font-semibold mt-3 text-2xl">
                Verify your mobile number
              </p>
              {/* <p className="text-black font-semibold mt-1 text-3xl">40% OFF</p> */}
              {/* <p className="text-black  p-1 text-xl">Until dd/mm/year</p> */}
            </div>
            <form
              onSubmit={sendotp}
              className="flex flex-col items-center   w-[100%] h-full   "
            >
              {/* <p className="w-[90%] ">Hurry, our coupon expires on 01/01/2024. Don't miss out on the savings! Extend your savings by redeeming your coupon before 01/01/2024.</p> */}
              <input
                type="text"
                ref={mobileref}
                required
                className="w-[50%] p-2 border border-border2  focus:outline-none"
                placeholder="Enter your mobile number"
              />
              {showotpinput ? (
                <input
                  type="password"
                  ref={otpref}
                  required
                  className="w-[50%] p-2 border mt-2 border-border2  focus:outline-none"
                  placeholder="Enter your otp"
                />
              ) : null}

              <button
                className="mt-4   bg-primary2 hover:bg-primary text-lg text-primary font-semibold  hover:text-bg3 py-2 px-4 w-[55%] hover:border-transparent "
                type="submit"
              >
                {buttonvalue}
              </button>
            </form>
          </div>
        </div>
      ) : null}
    </>
  );
}
